import { Button, ButtonGroup, Divider, ModalBody, ModalFooter, Stack, Text, useToast } from "@chakra-ui/react";
import { Form, Modal } from "components";
import { API, Mask } from "config";
import useShipments from "hooks/useShipments";
import { useRef, useState } from "react";

export default function Manual({ data, onSuccess = () => {}, ...props }){

    const toast = useToast()
    const submitRef = useRef()
    const shipments = useShipments()
    const [ shipment, setShipment ] = useState()
    const [ amount, setAmount ] = useState(data?.shipping_amount ? Mask.price(data?.shipping_amount) : '')
    const [ loading, setLoading ] = useState(false)    
    const [ errors, setErrors ] = useState()

    const handleSubmit = async () => {
        setLoading(true)
        setErrors(false)
        
        try{
            await API.post(`/orders/${data?.id}/quotation/manual`, { shipment_id: shipment, amount, _method: 'put' })
            toast({ title: 'Cotação salva!', status: 'success' })
            props.onClose()
            onSuccess()
        }catch(err){
            toast({ title: 'Não foi possível salvar a cotação.', description: err?.response?.data?.message, status: 'warning'})
            setErrors(err?.response?.data?.errors)
        }

        setLoading(false)
    }

    return(
    <Modal title="Cotação manual" loading={loading} {...props}>
        <ModalBody fontSize="sm">
            <Stack spacing={4}>
                <Text>Na cotação manual você deve selecionar a transportadora/serviço, e o valor total da entrega.</Text>
                <Divider />

                <Form.Form onSubmit={handleSubmit} submitRef={submitRef}>
                    <Form.Select
                        required
                        label="Tipo de serviço:"
                        value={shipment ?? ''}
                        options={shipments.data?.map(item => ({ label: item.label, value: item.id }))}
                        onChange={e => setShipment(e.target.value)}
                        isDisabled={loading}
                        error={errors?.shipment_id}
                    />

                    <Form.Text
                        required
                        label="Valor:"
                        leftAddon="R$"
                        value={amount}
                        onChange={e => setAmount(Mask.price(e.target.value))}
                        isDisabled={loading}
                        error={errors?.amount}
                    />
                </Form.Form>
            </Stack>
        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button children="Salvar cotação" isLoading={loading} isDisabled={!amount || !shipment} onClick={() => submitRef.current?.click()} />
                <Button children="Cancelar" colorScheme="red" onClick={props.onClose} />
            </ButtonGroup>
        </ModalFooter>
    </Modal>
    )
}